import { Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

const CertLink = styled(Typography).attrs((props) => ({
  as: "a",
  color: "primary",
  underline: true,
  ...props.theme.diamondSelector.certificateLink,
}))``

const SampleCertLink = ({ stoneType }) => {
  const certImage = stoneType === "04LABDIAM" ? "GIA-lab-cert" : "GIA-cert"
  return (
    <CertLink
      href={`${sl.config.jewlr_asset_url}images/product/diamond/${certImage}.jpg`}
      target="_blank"
    >
      View Sample Certificate
    </CertLink>
  )
}

SampleCertLink.propTypes = {
  stoneType: PropTypes.string,
}

export default SampleCertLink
